import type { ComponentProps } from 'react';
import { cn } from '../lib/cn.ts';

export type SkeletonShape = 'block' | 'text' | 'circle';

const shapes: Record<SkeletonShape, string> = {
  block: 'rounded-md' /* 12px — measured on the product's loading tiles */,
  text: 'h-4 rounded-xs',
  circle: 'rounded-full',
};

export interface SkeletonProps extends ComponentProps<'div'> {
  shape?: SkeletonShape;
}

/**
 * A block standing in for content that has not arrived.
 *
 * `surface-sunken`, not a shimmer: the product greys out the shape and leaves
 * it still, which stops a loading grid from strobing when twenty of them
 * animate at once.
 */
export function Skeleton({ shape = 'block', className, ...props }: SkeletonProps) {
  return (
    <div
      aria-hidden
      className={cn('animate-pulse bg-surface-sunken', shapes[shape], className)}
      {...props}
    />
  );
}
